// extracted by mini-css-extract-plugin
export default {"root":"BackToLocation_root__6S55F","backToLocation":"BackToLocation_backToLocation__TCUFa","backToLocation__link":"BackToLocation_backToLocation__link__z866l"};